import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Form, message, Upload } from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import SummaryApi from "../../../common/index";

function ManageCategories({ token }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();
  const [iconFile, setIconFile] = useState(null);
  const [fileList, setFileList] = useState([]);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  // Fetch categories
const fetchCategories = async () => {
  setLoading(true);
  try {
    const res = await axios({
      url: SummaryApi.getCategories.url,
      method: SummaryApi.getCategories.method,
      headers: { Authorization: `Bearer ${token}` },
    });
    
    
    const categoriesArray = Array.isArray(res.data.categories) ? res.data.categories : [];
    setCategories(categoriesArray);
  } catch (err) {
    message.error("Failed to fetch categories");
  }
  setLoading(false);
};


  useEffect(() => {
    fetchCategories();
  }, []);

  // Open modal for Add/Edit
  const openModal = (category = null) => {
    setEditingCategory(category);
    if (category && category.icon) {
  setFileList([
    {
      uid: "-1",
      name: category.icon,
      status: "done",
      url: `${BASE_URL}/uploads/categories/${category.icon}`,
    },
  ]);
} else {
  setFileList([]);
}

    form.setFieldsValue(category ? { name: category.name } : { name: "" });
    setIconFile(null);
    setModalVisible(true);
  };

  // Handle Add/Edit submit
  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      if (iconFile) formData.append("icon", iconFile);

      if (editingCategory) {
        // Update category
        await axios({
          url: `${SummaryApi.updateCategory.url}/${editingCategory.id}`,
          method: SummaryApi.updateCategory.method,
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        message.success("Category updated successfully");
      } else {
        // Add category
        await axios({
          url: SummaryApi.addCategory.url,
          method: SummaryApi.addCategory.method,
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        message.success("Category added successfully");
      }

      fetchCategories();
      setModalVisible(false);
    } catch (err) {
      message.error("Operation failed");
    }
  };

  // Handle Delete
  const handleDelete = async (id) => {
    try {
      await axios({
        url: `${SummaryApi.deleteCategory.url}/${id}`,
        method: SummaryApi.deleteCategory.method,
        headers: { Authorization: `Bearer ${token}` },
      });
 
      message.success("Category deleted successfully");
      fetchCategories();
    } catch (err) {
      message.error("Delete failed");
    }
  };

  const columns = [
    {
  title: "S.No",
  key: "index",
  render: (_, __, index) => index + 1,
},

    {
      title: "Icon",
      dataIndex: "icon",
      key: "icon",
      render: (_, record) =>
        record.icon ? (
          <img
            src={`${BASE_URL}/uploads/categories/${record.icon}`}
            alt="icon"
            style={{ width: 40, height: 40, objectFit: "contain" }}
          />
        ) : (
          "—"
        ),
    },
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button onClick={() => openModal(record)} style={{ marginRight: 8 }}>
            Edit
          </Button>
          <Button danger onClick={() => handleDelete(record.id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div>
      <h2>Manage Categories</h2>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => openModal()}
        style={{ marginBottom: 16 }}
      >
        Add Category
      </Button>

     <Table
  columns={columns}
  dataSource={Array.isArray(categories) ? categories : []}
  rowKey={(record) => record.id} // ensures stable keys
  loading={loading}
/>
      <Modal
        title={editingCategory ? "Edit Category" : "Add Category"}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label="Category Name"
            rules={[{ required: true, message: "Please enter category name" }]}
          >
            <Input placeholder="Enter category name" />
          </Form.Item>
<Form.Item name="icon" label="Category Icon (optional)">
  <Upload
    listType="picture"
    fileList={fileList}
    beforeUpload={(file) => {
      setIconFile(file);
      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          originFileObj: file,
        },
      ]);
      return false;
    }}
    onRemove={() => {
      setFileList([]);
      setIconFile(null);
    }}
  >
    <Button icon={<UploadOutlined />}>Upload Icon</Button>
  </Upload>
</Form.Item>
</Form>
      </Modal>
    </div>
  );
}
export default ManageCategories;
